import React, { ReactNode } from 'react';
import { View, ViewStyle } from 'react-native';

import styles from './lesson-accent-banner.style';
import { ThemedView } from '../themed-view';

interface LessonAccessBannerProps {
  style?: ViewStyle;
  innerContainerStyle?: ViewStyle;
  accentStyle?: ViewStyle;
  children: ReactNode;
}

export default function LessonAccentBanner({
  style,
  innerContainerStyle,
  accentStyle,
  children,
}: LessonAccessBannerProps) {
  return (
    <View style={[styles.container, style]}>
      <ThemedView style={[styles.accent, accentStyle]} />
      <View style={[styles.innerContainer, innerContainerStyle]}>
        {children}
      </View>
    </View>
  );
}
